import type { ProductResponse } from "../../admin/products/productsApi";
import type { ProviderListResponseItem } from "../../admin/providers/providersApi";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";

interface OrderProductInput {
  readonly id: string;
  readonly providerId?: string;
  readonly date: string;
}

export function calculateDefaultCancellationDate(
  products: OrderProductInput[],
  providers: ProviderListResponseItem[],
  catalog: ProductResponse[],
): string | null {
  const dates = products
    .map((product) => {
      const providerId = product.providerId ?? catalog.find((p) => p.id === product.id)?.provider.id;
      if (!providerId) {
        return null;
      }
      const provider = providers.find((p) => p.id === providerId);
      const freeCancellationDays = provider?.freeCancellationDays;
      if (!freeCancellationDays) {
        return null;
      }
      return dayjs(product.date, ISO_DATE_FORMAT).subtract(freeCancellationDays, "days").format(ISO_DATE_FORMAT);
    })
    .filter((d) => d !== null);

  if (dates.length === 0) {
    return null;
  }
  return dates.reduce((min, d) => (d < min ? d : min));
}
